import { render } from "./Redirect.vue?vue&type=template&id=534c6b5c"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"
script.render = render

export default script